import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/library/card";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

// Your exact clean style
const DetailItem = ({ label, value }: { label: string; value: any }) => (
  <div className="flex flex-col min-w-0">
    {" "}
    {/* min-w-0 prevents overflow */}
    <p className="text-b4 text-[var(--color-black-6)] truncate">{label}</p>
    <Tooltip>
      <TooltipTrigger asChild>
        <p className="text-b3 text-[var(--color-black-10)] truncate">
          {value || "N/A"}
        </p>
      </TooltipTrigger>
      <TooltipContent className="bg-slate-900 text-white text-xs border-0">
        {value}
      </TooltipContent>
    </Tooltip>
  </div>
);

// Helper to extract fields
const getRenderableFields = (item: any) => {
  const fields: { label: string; value: string }[] = [];

  // 1. Virtual Fields (Qualification, Level, etc.)
  Object.keys(item).forEach((key) => {
    const val = item[key];
    if (typeof val === "object" && val?.isVirtual) {
      fields.push({ label: val.label, value: val.value });
    }
  });

  // 2. Main Value (Score) - Always Last
  if (item.value) {
    fields.push({ label: item.label || "Value", value: item.value });
  }
  return fields;
};

export default function ScopeViewRendererCard({ title, items }: any) {
  return (
    <Card className="w-full gap-0 border border-[#e6e8e7] shadow-none rounded-[12px] bg-white overflow-hidden py-0">
      <CardHeader className="px-3 py-2">
        <CardTitle className="text-[14px] font-medium text-black tracking-[-0.28px] leading-normal">
          {title}
        </CardTitle>
      </CardHeader>

      <CardContent className="p-0 pb-1.5">
        <div className="flex flex-col divide-y divide-gray-100">
          {items.map((item: any, index: number) => {
            const fields = getRenderableFields(item);

            return (
              <div key={item.id || index} className="px-3 py-1">
                <div className="flex flex-wrap gap-x-8 gap-y-2">
                  {fields.map((field, fIndex) => (
                    <DetailItem
                      key={fIndex}
                      label={field.label}
                      value={field.value}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
